import { render } from "./email.vue?vue&type=template&id=350b4506&scoped=true&ts=true"
import script from "./email.vue?vue&type=script&lang=ts"
export * from "./email.vue?vue&type=script&lang=ts"

import "./email.vue?vue&type=style&index=0&id=350b4506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350b4506"],['__file',"src/components/inputs/email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "350b4506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('350b4506', __exports__)) {
    api.reload('350b4506', __exports__)
  }
  
  module.hot.accept("./email.vue?vue&type=template&id=350b4506&scoped=true&ts=true", () => {
    api.rerender('350b4506', render)
  })

}


export default __exports__